// extracted by mini-css-extract-plugin
export var link = "_v4-0";